module.exports = __webpack_public_path__ + "img/logo.5371d38b.png";